import React from 'react';
import { MdOutlineImage } from 'react-icons/md';
import { Container } from './styles';

export type PlaceholderImageProps = {
  size?: number;
  color?: string;
};

const PlaceholderImage = (props: PlaceholderImageProps) => {
  const { size = 65, color = '#262BA6' } = props;

  return (
    <Container size={size}>
      <MdOutlineImage color={color} size={size} />
    </Container>
  );
};

export default PlaceholderImage;
